import { ApplicationsTableView } from "shared/app/ApplicationsTableView";
import { UnitDetails } from "./UnitDetails";
import { Unit } from "types/landlord/address";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { DiscountCodesTab } from "./DiscountCodesTab";
import { LeadsTableView } from "shared/app/LeadsTableView";
import { ShowingAvailabilityTab } from "./ShowingAvailabilityTab";
import { SHOWING_AVAILABILITY_TAB_LABEL } from "./ShowingAvailabilityTab/constants";
import { ActivityLogTab } from "./ActivityLogTab";
import { AnalyticsTab } from "./AnalyticsTab";
import { WaitlistTab } from "./WaitlistTab";
import { FraudAlertsTab } from "./FraudAlertsTab";
import {
  ACTIVITY_LOG_TAB_LABEL,
  ANALYTICS_TAB_LABEL,
  FRAUD_ALERTS_TAB_LABEL,
  WAITLIST_TAB_LABEL
} from "./tabConstants";

interface TabContentProps {
  tab: string;
  unit?: Unit;
}

export const TabContent = ({ tab, unit }: TabContentProps) => {
  const dictionary = useUnitsPropertiesDictionary();

  const renderTabContent = () => {
    switch (tab) {
      case "Applications":
        return (
          <div className="mt-4">
            <ApplicationsTableView unitId={Number(unit?.id)} />
          </div>
        );
      case `${dictionary.Units} details`:
        return <UnitDetails unit={unit} />;

      case "Leads":
        return (
          <LeadsTableView
            property_ids={unit?.property?.id ? [String(unit.property.id)] : []}
            unit_ids={unit?.id ? [String(unit.id)] : []}
            createLeadDefaults={{
              property: unit?.property
                ? { id: unit.property.id, name: unit.property.name }
                : undefined,
              unit: unit?.id ? { id: unit.id, title: unit.title } : undefined
            }}
          />
        );
      case SHOWING_AVAILABILITY_TAB_LABEL:
        return (
          <ShowingAvailabilityTab
            propertyId={unit?.property?.id}
            unitId={unit?.id}
          />
        );
      case ACTIVITY_LOG_TAB_LABEL:
        return (
          <ActivityLogTab propertyId={unit?.property?.id} unitId={unit?.id} />
        );
      case WAITLIST_TAB_LABEL:
        return <WaitlistTab unitId={unit?.id} />;
      case ANALYTICS_TAB_LABEL:
        return <AnalyticsTab unitId={Number(unit?.id)} />;
      case FRAUD_ALERTS_TAB_LABEL:
        return <FraudAlertsTab unitId={unit?.id} />;
      case "Discount codes":
        return <DiscountCodesTab />;
      default:
        return null;
    }
  };

  return <>{renderTabContent()}</>;
};
